import { QSetReviewSubtaskProvider } from '@exam-management/qset-review-subtask-details';
import { useParams } from '@exam-management/router';
import {
  QSetReviewModalProvider,
  TaskManagementPermissionRoute,
} from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QSetReviewSubtaskLayout() {
  const { subTaskId } = useParams('/my-task/qset-review/:taskId/subtask/:subTaskId');

  return (
    <TaskManagementPermissionRoute taskId={subTaskId}>
      <QSetReviewSubtaskProvider subtaskId={subTaskId}>
        <QSetReviewModalProvider>
          <Outlet />
        </QSetReviewModalProvider>
      </QSetReviewSubtaskProvider>
    </TaskManagementPermissionRoute>
  );
}
